import useReduxValue from "./useReduxValue";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const useReportBusynessReduxTable = (
    rowsSelector,
    fetchRowsAction,
    columnsSelector,
    fetchColumnsAction,
    selectedIdsSelector,
    setSelectedIdsAction,
    searchStringSelector,
    setSearchStringAction,
    pageNumberSelector,
    setPageNumberAction,
    limitNumberSelector,
    setLimitNumberAction,
    sortDataSelector,
    setSortDataAction,
    filterDataSelector,
    setFilterDataAction,
    errorSelector,
    setErrorAction,
    totalSelector,
    busySelector,
    calcDateSelector,
    compensationFlSelector,
    setCompensationFlAction,
    viewType
) => {

    const dispatch = useDispatch();

    const rows = useSelector(rowsSelector);
    const columns = useSelector(columnsSelector);
    const total = useSelector(totalSelector);
    const busy = useSelector(busySelector);

    const calcDate = useSelector(calcDateSelector)

    const [selectedIds, setSelectedIds] = useReduxValue(selectedIdsSelector, setSelectedIdsAction);
    const [searchString, setSearchString] = useReduxValue(searchStringSelector, setSearchStringAction);
    const [pageNumber, setPageNumber] = useReduxValue(pageNumberSelector, setPageNumberAction);
    const [limitNumber, setLimitNumber] = useReduxValue(limitNumberSelector, setLimitNumberAction);
    const [sortData, setSortData] = useReduxValue(sortDataSelector, setSortDataAction);
    const [filterData, setFilterData] = useReduxValue(filterDataSelector, setFilterDataAction);
    const [error, setError] = useReduxValue(errorSelector, setErrorAction);
    const [compensationFl, setCompensationFl] = useReduxValue(compensationFlSelector, setCompensationFlAction);


    useEffect(() => {
        if (columns.length > 0) return;
        dispatch(fetchColumnsAction());
    }, [columns.length, fetchColumnsAction, dispatch]);

    useEffect(() => {
        dispatch(fetchRowsAction({
            params: {
                search: searchString,
                filters: filterData,
                page: pageNumber,
                limit: limitNumber,
                sorters: sortData,
                calcDate: calcDate,
                compensationFl: compensationFl
            }
        }));
    }, [dispatch, fetchRowsAction, searchString, filterData, pageNumber, limitNumber, sortData, calcDate, compensationFl]);

    useEffect(() => {
        const compensationFilter = filterData.find(item => item.field === "compensation_id")

        if (compensationFl && compensationFilter && !viewType) {
            const newFilterData = filterData.filter(item => item.field !== "compensation_id")

            setFilterData(newFilterData)
        }
    }, [filterData, setFilterData, compensationFl, viewType])
    
    return {
        rows, columns,
        total, busy,
        selectedIds, setSelectedIds,
        searchString, setSearchString,
        pageNumber, setPageNumber,
        limitNumber, setLimitNumber,
        sortData, setSortData,
        filterData, setFilterData,
        error, setError, compensationFl, setCompensationFl
    }
};

export default useReportBusynessReduxTable;
